<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
  <v-card class="mx-auto" max-width="600" elevation="4">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  <v-card-title>
    <v-icon class="mr-2" color="primary">mdi-account-edit</v-icon>
    <span class="text-h6 font-weight-medium">Editar Cliente</span>
  </v-card-title>

  <v-form v-model="formValido" ref="form">
    <v-card-text>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="clienteOriginal.nome"
              label="Nome"
              prepend-inner-icon="mdi-account"
              :rules="[v => !!v || 'O nome é obrigatório']"
              required
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="clienteOriginal.nif"
              label="NIF"
              prepend-inner-icon="mdi-card-account-details"
              :rules="[v => !!v || 'O NIF é obrigatório']"
              required
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="clienteOriginal.telefone"
              label="Telefone"
              prepend-inner-icon="mdi-phone"
              :rules="[v => !!v || 'O telefone é obrigatório']"
              required
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="clienteOriginal.email"
              label="Email"
              prepend-inner-icon="mdi-email"
              :rules="[
                v => !!v || 'O email é obrigatório',
                v => /.+@.+\..+/.test(v) || 'Formato de email inválido'
              ]"
              required
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="clienteOriginal.endereco"
              label="Endereço"
              prepend-inner-icon="mdi-map-marker"
              :rules="[v => !!v || 'O endereço é obrigatório']"
              required
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text color="red" @click="fechar">
        <v-icon left>mdi-close</v-icon> Cancelar
      </v-btn>
      <v-btn color="primary" :disabled="!formValido || overlay" @click="salvar">
        <v-icon left>mdi-content-save</v-icon> Salvar
      </v-btn>
    </v-card-actions>
  </v-form>
</v-card>

  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2';
import axios from '../../../../plugins/axios'
export default {
  props: {
    value: Boolean, // controle do dialog vindo do pai
    clienteOriginal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: this.value,
      formValido: false,
      overlay: false,
      cliente: { ...this.clienteOriginal } // cópia local para edição
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit('input', val);
    }
  },

  
  methods: {
    fechar() {
      this.dialog = false;
    },
   async salvar() {


     try {
         this.overlay = true
        let response = await axios.post('editarInfoCliente',this.clienteOriginal).then((res)=>res.data)
        if(response.affectedRows >= 1){
            Swal.fire('Informação','Informações actualizadas com sucesso','success')
            this.$emit('cliente-editado', this.cliente);
        }
     } catch (error) {
         Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
     }finally{
       this.overlay = false
     }

     // 
     // this.fechar();
    }
  }
};
</script>
